import { Link } from 'react-router-dom';
import { SETTINGS_STORE } from '../stores/SettingsStore';
import useObservableListener from '../utils/useObservableListener';

function Settings() {
  const wordsUppercase = useObservableListener(SETTINGS_STORE.wordsUppercase);
  const errorsThreshold = useObservableListener(SETTINGS_STORE.errorsThreshold);
  const readEveryWord = useObservableListener(SETTINGS_STORE.readEveryWord);

  return (
    <div className="container py-4">
      <div className="text-center">
        <h1 className="mb-4">Settings</h1>
        <div className="mx-auto text-start p-3" style={{ maxWidth: '600px' }}>

          <div className="mb-4">
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="wordsUppercase"
                checked={wordsUppercase}
                onChange={(e) => SETTINGS_STORE.wordsUppercase.set(e.target.checked)}
              />
              <label className="form-check-label" htmlFor="wordsUppercase">
                Words uppercase
              </label>
            </div>
            <small className="text-muted">Display quiz answer words in uppercase</small>
          </div>

          <div className="mb-4">
            <label htmlFor="errorsThreshold" className="form-label">
              Errors threshold: {errorsThreshold}
            </label>
            <input
              type="range"
              className="form-range"
              id="errorsThreshold"
              min="0"
              max="1"
              step="0.1"
              value={errorsThreshold}
              onChange={(e) => SETTINGS_STORE.errorsThreshold.set(parseFloat(e.target.value))}
            />
            <small className="text-muted">
              Pass if errors &lt; words &times; {errorsThreshold} (e.g. 8 words &rarr; less than {Math.floor(8 * errorsThreshold)} errors to pass)
            </small>
          </div>

          <div className="mb-4">
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="readEveryWord"
                checked={readEveryWord}
                onChange={(e) => SETTINGS_STORE.readEveryWord.set(e.target.checked)}
              />
              <label className="form-check-label" htmlFor="readEveryWord">
                Read every word
              </label>
            </div>
            <small className="text-muted">Read each selected word aloud during the quiz (even wrong ones)</small>
          </div>

          <p className="mt-5">
            <Link to="/" className="text-primary">← Back to Home</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Settings;
